const Department = () =>
  import(
    /* webpackChunkName: "base-info-crm-department" */ '@/pages/base-info/crm/department/index.vue'
  )
const CreateDepartment = () =>
  import(
    /* webpackChunkName: "base-info-crm-department" */ '@/pages/base-info/crm/department/create.vue'
  )
const EditDepartment = () =>
  import(
    /* webpackChunkName: "base-info-crm-department" */ '@/pages/base-info/crm/department/edit.vue'
  )

export default {
  path: 'department',
  meta: {
    label: 'department',
    auth: 'department'
  },
  component: {
    name: 'Department',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCrmDepartment',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Department
    },
    {
      name: 'BaseInfoCreateCrmDepartment',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateDepartment
    },
    {
      name: 'BaseInfoEditCrmDepartment',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditDepartment,
      props: true
    }
  ]
}
